import { render, staticRenderFns } from "./Schokolade.vue?vue&type=template&id=11a66a34&scoped=true"
import script from "./Schokolade.vue?vue&type=script&lang=js"
export * from "./Schokolade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11a66a34",
  null
  
)

export default component.exports